document.addEventListener("DOMContentLoaded", function () {
    function updateFilters() {
        let filterForm = document.querySelector(".CollectionFiltersForm");
        if (!filterForm) return;

        let formData = new FormData(filterForm);
        let queryString = new URLSearchParams(formData).toString();
        let newUrl = window.location.pathname + "?" + queryString;

        fetch(newUrl + "&section_id=main-collection", {
            method: "GET",
            headers: { "X-Requested-With": "XMLHttpRequest" }
        })
        .then(response => response.text())
        .then(html => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(html, "text/html");

            // 📌 **Ürünleri Güncelle**
            let newProducts = doc.querySelector(".ProductList");
            let oldProducts = document.querySelector(".ProductList");
            if (newProducts && oldProducts) {
                oldProducts.innerHTML = newProducts.innerHTML;
                console.log("✅ Ürün listesi AJAX ile güncellendi!");
            }

            // 📌 **TÜM FİLTRELERİ Güncelle**
            let updatedFilters = doc.querySelector(".CollectionFiltersForm");
            let currentFilters = document.querySelector(".CollectionFiltersForm");
            if (updatedFilters && currentFilters) {
                currentFilters.innerHTML = updatedFilters.innerHTML;
                attachFilterEvents(); // Yeniden filtre olaylarını bağla
                document.dispatchEvent(new Event('shopify:section:load')); // Shopify'ye güncellendiğini bildir
                console.log("✅ Filtreler AJAX ile güncellendi!");
            }

            // 📌 **URL'yi güncelle (Sayfa yenilemeden)**
            window.history.pushState({}, "", newUrl);
        })
        .catch(error => console.error("⚠️ Filtreleme hatası:", error));
    }

    function attachFilterEvents() {
        let filterInputs = document.querySelectorAll(".CollectionFiltersForm input, .Facets input");
        filterInputs.forEach(input => {
            input.addEventListener("change", updateFilters);
        });
    }

    attachFilterEvents();

    // 📌 **Observer ile DOM değişikliklerini takip et**
    const observer = new MutationObserver(mutations => {
        let filtersUpdated = false;
        mutations.forEach(mutation => {
            if (mutation.addedNodes.length) {
                filtersUpdated = true;
            }
        });

        if (filtersUpdated) {
            console.log("♻️ DOM değişti, filtreler ve ürünler yenileniyor...");
            updateFilters();
            document.dispatchEvent(new Event('shopify:section:load')); // Shopify'ye güncellendiğini bildir
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener("shopify:section:load", function() {
        console.log("♻️ Shopify AJAX ile sayfa güncellendi, filtreler ve ürünler yenileniyor...");
        updateFilters();
    });
});
